import React from "react"
import Link from "./link";
import { domain } from '../utils';
import { graphql } from 'gatsby';

const CardArticle = ({ article, path ,showMobileImage, shouldNotLazyLoad}) => {
  const [mousemovePosition, setMouseMovePosition] = React.useState({
    positionX: "-50px", 
    positionY: "-50px"
  })
    const handleMouseMove = (event) => {
    const containerRect = event.currentTarget.getBoundingClientRect();
    const positionX = event.clientX - containerRect.left;
    const positionY = event.clientY - containerRect.top;
    setMouseMovePosition({
      positionX: `${positionX}px`,
      positionY: `${positionY}px`,
    });
  };

  const handleMouseEnter = () => {
  };

  const handleMouseLeave = () => {
    setMouseMovePosition(
      {
        positionX: "-50px", 
        positionY: "-50px"
      }
    )
  };

  if (!article) { return <article></article>; }

  return (
    <article
      className="card-article col"
      role="listitem"
    >
      <Link
        className="card-article__wrap"
        to={`/${article.language}/${path}/${article.slug}`}
        title={article.title}
      >

        <div className="card-article__image nocursor"
           onMouseMove={(ev)=> handleMouseMove(ev)}
           onMouseLeave={handleMouseLeave}
           handleMouseEnter={handleMouseEnter}
        > 
           <div className="case-list__image-cursor" style={{ left: mousemovePosition.positionX, top: mousemovePosition.positionY , cursor:"none" }}></div>
          {showMobileImage ? (
            <picture>
              <source media="(min-width: 768px)" srcSet={`${article.headerImage && article.headerImage.url}`} />
              <source media="(max-width: 767px)" srcSet={`${article.headerImageMobile && article.headerImageMobile.url}`} />
              <img src={`${article.headerImageMobile && article.headerImageMobile.url}`} alt={article.title} className="image--fluid" {...(!shouldNotLazyLoad && { loading: "lazy" })} />
            </picture>

          ): (
            <img
              className = "image--fluid"
                src = {`${article.headerImage && article.headerImage.url}`}
                alt="placeholder"
                loading="lazy"
            />
            )}

        </div>
        {/*
        <div className="card-article__meta">
          <date className="card-article__date">
            {article.date && article.date
              .split("-")
              .reverse()
              .join(".")}
          </date>
          <div className="tags" role="list">
            {article.tags && article.tags.map(({ tag }) => (
              <>
                <Link
                  to={`/${article.language}/${tag}`}
                  title={tag}
                >{`#${tag}`}</Link>{" "}
              </>
            ))}
          </div>
        </div>
        */}
        <h2 className="card-article__header">
          {article.title}
        </h2>
      </Link>
    </article>
  )
}

export const query = graphql`
  fragment CardArticleBlog on STRAPI_Blog {
    language
    slug
    headerImage {
      url
    }
    headerImageMobile {
      url
    }
    title
    intro
    tags {
      tag
    }
    date
  }
  fragment CardArticleCaseStudy on STRAPI_CaseStudy {
    language
    slug
    inactive
    headerImage {
      url
    }
    headerImageMobile{
      url
    }
    title
    description
    tags {
      tag
    }
    date
  }
`

export default CardArticle